// import { Container, Content, ContentLinks, Link, Links, Logo } from './styles';
import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect, useState } from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { LinkMenu } from './styles';

export default function Menu() {
  const [fixedMenu, setFixedMenu] = useState('');
  const [expanded, setExpanded] = useState(false);
  
  const handleScroll = () => {
    const position = window.pageYOffset;
    if(position > 50)
     setFixedMenu('sticky-top') 
    else
     setFixedMenu('');
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  });

  return(
    <div className={`${fixedMenu}`}>
      <Navbar expand="lg" expanded={expanded} className={`clearfix no-padding nav-color`}>
        <Container>
          <div className="logo-style float-left text-center text-warning ">
            Masters Pool with the<br /> <span className="text-success fw-bold">Big Guy</span> 
          </div>
          <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={() => setExpanded(!expanded)}/>
          <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <LinkMenu onClick={() => setExpanded(false)} to="home" className="text-lg-center">Home </LinkMenu>
            <LinkMenu onClick={() => setExpanded(false)} to="leaderboard" className="text-lg-center">Leaderboard</LinkMenu>
            <LinkMenu onClick={() => setExpanded(false)} to="scoreboards" className="text-lg-center">Scorecards</LinkMenu>
            <LinkMenu onClick={() => setExpanded(false)} to="selections" className="text-lg-center">Selections</LinkMenu>
            <LinkMenu onClick={() => setExpanded(false)} to="geography" className="text-lg-center">Geography</LinkMenu>
            <LinkMenu onClick={() => setExpanded(false)} to="whatif" className="text-lg-center">What if?</LinkMenu>
            <LinkMenu onClick={() => setExpanded(false)} to="predictions" className="text-lg-center">Predictions</LinkMenu>
            {/* <LinkMenu onClick={() => setExpanded(false)} to="emotions" className="text-lg-center">Fan Engagement</LinkMenu> */}
            <LinkMenu onClick={() => setExpanded(false)} to="about" className="text-lg-center">About IPC</LinkMenu>
          </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  )
}